// extracted by mini-css-extract-plugin
export default {"bar_container":"AboutBar_bar_container__yhOFG","bar_sub_container":"AboutBar_bar_sub_container__4fyIv","bar_heading_container":"AboutBar_bar_heading_container__FwRjR"};